import { Controller } from '@hotwired/stimulus';

// Tiny Stimulus controller that adds the 'hidden' class on an element.
export default class HideElementController extends Controller {
  hide(): void {
    this.element.classList.add('hidden');
  }
}
